// SuchStatus.tsx — die Zeile unter einem Suchfeld: „Suche …", „Keine Treffer."
// oder „Suche fehlgeschlagen — erneut versuchen". Gehört zu useEntprellteSuche.

import * as React from "react";
import { REFINED } from "../../risikoanalyseStep/tokens";
import { SUCHE_MIN_ZEICHEN, type EntprellteSuche } from "../../../hooks/useEntprellteSuche";

export function SuchStatus({
  suche,
  term,
  className,
  anzahl,
}: {
  suche: Pick<EntprellteSuche<unknown>, "laedt" | "fehler" | "zuLange" | "erneut">;
  term: string;
  className?: string;
  /** Anzahl der ANGEZEIGTEN Treffer (nach evtl. Filter); Standard: keine. */
  anzahl: number;
}) {
  if (term.trim().length < SUCHE_MIN_ZEICHEN) return null;
  if (suche.laedt) return <div className={className}>Suche …</div>;
  if (suche.fehler) {
    return (
      <div className={className} role="alert">
        {suche.zuLange ? "Suche dauert zu lange" : "Suche fehlgeschlagen"} —{" "}
        <button
          type="button"
          onClick={suche.erneut}
          // onMouseDown verhindert, dass das Suchfeld den Fokus verliert und
          // ein Dropdown sich schließt, bevor der Klick ankommt.
          onMouseDown={(e) => e.preventDefault()}
          style={{
            border: "none",
            background: "none",
            padding: 0,
            font: "inherit",
            color: REFINED.aub,
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          erneut versuchen
        </button>
      </div>
    );
  }
  if (anzahl === 0) return <div className={className}>Keine Treffer.</div>;
  return null;
}
